// @ts-check

//
// Entry point for stand-alone transfer calculator app
//

import React from 'react';
import ReactDOM from 'react-dom';
import '../index.scss';

import App from './components/App';

const el = window.document.getElementById('app');

ReactDOM.render(<App />, el);
